import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "uk-overflow-auto" }
const _hoisted_2 = { class: "uk-container uk-margin-top" }
const _hoisted_3 = { class: "uk-table uk-table-hover uk-table-middle uk-table-divider" }
const _hoisted_4 = { class: "uk-margin-remove" }
const _hoisted_5 = { class: "uk-text-meta uk-margin-small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterSelector = _resolveComponent("FilterSelector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FilterSelector, {
        options: _ctx.drivers,
        label: "fullName",
        onSelect: _ctx.selectDriver
      }, null, 8, ["options", "onSelect"])
    ]),
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chats, (chat, chatIdx) => {
          return (_openBlock(), _createElementBlock("tr", { key: chatIdx }, [
            _createElementVNode("td", null, [
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("strong", null, _toDisplayString(chat.driver.displayName), 1)
              ]),
              _createElementVNode("p", _hoisted_5, _toDisplayString(chat.latestMessage.text), 1)
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("td", null, [
              _createElementVNode("p")
            ], -1)),
            _cache[1] || (_cache[1] = _createElementVNode("td", { class: "uk-text-truncate" }, "02/20/20", -1))
          ]))
        }), 128))
      ])
    ])
  ]))
}